var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-ellipsis" }, [
    _c(
      "div",
      { staticClass: "table-ellipsis__text" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c(
          "a",
          _vm._b(
            {
              staticClass: "table-ellipsis__name linked-name",
              attrs: { href: _vm.href, target: "_blank", title: _vm.title }
            },
            "a",
            _vm.$attrs,
            false
          ),
          [
            _vm._t("link-content", function() {
              return [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
            })
          ],
          2
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }